import React from 'react'
import type { EquityFormData } from 'submission/lib/equity-form-defaults'

type Props = {
  form: EquityFormData
  setForm: React.Dispatch<React.SetStateAction<EquityFormData>>
}

const TOGGLES: Array<{
  key: keyof EquityFormData
  label: string
}> = [
  { key: 'accessoryMarketing', label: 'Marketing' },
  { key: 'accessoryKolCampaigns', label: 'KOL campaigns' },
  { key: 'accessoryMarketMaking', label: 'Market making' },
  { key: 'accessoryTreasuryManagement', label: 'Treasury management' },
  { key: 'accessoryOtcDeals', label: 'OTC deals' },
  { key: 'accessoryAuditing', label: 'Auditing' },
  { key: 'accessoryHrRecruitment', label: 'HR / recruitment' },
  { key: 'accessoryCexListing', label: 'CEX listing' },
]

const AccessorySection: React.FC<Props> = ({ form, setForm }) => {
  return (
    <section className="bg-white border border-slate-200 rounded p-6">
      <h2 className="text-lg font-semibold text-slate-900 mb-4">
        Accessory services
      </h2>
      <div className="grid grid-cols-2 gap-2">
        {TOGGLES.map((t) => (
          <label key={t.key} className="inline-flex items-center text-sm">
            <input
              type="checkbox"
              className="mr-2"
              checked={form[t.key] as boolean}
              onChange={(e) =>
                setForm((p) => ({ ...p, [t.key]: e.target.checked }))
              }
            />
            {t.label}
          </label>
        ))}
      </div>
      <label className="flex flex-col text-sm mt-3">
        <span className="text-slate-700 mb-1">Other</span>
        <input
          className="border rounded px-2 py-1 text-slate-900 bg-white"
          value={form.accessoryOther}
          onChange={(e) =>
            setForm((p) => ({ ...p, accessoryOther: e.target.value }))
          }
        />
      </label>
    </section>
  )
}

export default AccessorySection
